
import Multiselect from "vue-multiselect";
import { Component, Prop, Vue } from 'vue-property-decorator';
import {ajaxGet} from "../data/ajax";
import { GraphUserModel } from '../models/GraphUserModel';

@Component({
    components: { Multiselect },
})

export default class PeopleSearch extends Vue {	
    @Prop() private value: any;
    @Prop({ default: []}) public excludeUsers!: string[];
	users: any = [];
	isLoading: boolean = false;
	debounce: number = 0

    get input(){
        return this.value;
    }
    set input(value){
        this.$emit("input", value);
    }
	
    async asyncFind(searchWords: string) {
        var model = this;
        model.isLoading = true;
        if (searchWords.length >= 3) {
            var d = ++model.debounce;
            return new Promise<void>((resolve, reject) => {
                setTimeout(function() {
                    if (model.debounce == d) {
                        resolve();
                    }
                }, 300);
            }).then(async function() {
                var url = process.env.VUE_APP_ROOT_API + "User/Find?term=" + searchWords;
                var token = await model.$store.state.authModule.getapiTokenPopup();
                var users = await ajaxGet(url, token);
                var filteredUsers = users.filter(function(user: GraphUserModel){
                    return !model.excludeUsers.includes(user.mail);
                })
                model.users = filteredUsers;
                model.debounce = 0;
            });
        }
        model.isLoading = false;
    }

    clearAll(): void {
        this.input = [];
    }
	
};
